<template>
  <vs-row
  vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
    <select v-model="status" @change ="handleStatusChnage()" name="cars" id="cars" form="carform" class="w-100 selectExample mt-2 customSelect">
      <option :key="index" :value="item.id" :label="item.status" v-for="(item,index) in params.data.live_status_list" class="selectOptionclass"/>
    </select>
  </vs-row>
</template>
<script>
import { taskUpdate } from '@/api/task-project.js'
export default {
  data () {
    return {
      status: null
    }
  },
  mounted () {
    this.status = this.params.data.status.id
  },
  methods: {
    async handleStatusChnage () {
      try {
        const task_id = this.params.data.id
        const payload = {
          updateField: {
            task_status_id: this.status
          }
        }
        taskUpdate(localStorage.getItem('customer_id'), task_id, payload)
          .then((res) => {
            console.log(res)
            this.$vs.notify({
              title: 'Success',
              text: 'Task Updated Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
            
          })
          .catch((e) => {
            console.log(e)
            this.$vs.notify({
              title: 'Warning',
              text: 'Something Went Wrong',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          })
    
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          title: 'Warning',
          text: e,
          ...this.warnProp()
        })
      }
     
    }
  }
}
</script>
<style scoped>
  .customSelect {
    border-radius:3px;
    border: 1px solid #CCCCCC;
    width: 100%;
    height:30px;
    background-color: white;
    color:#757575
    /* font-family: $font-family-base'; */
  }
  .selectOptionclass :hover
  {
    background-color:yellow;
    color:white;
    border:none;
  }

</style>
